import React, { FC } from 'react';
import FileItem, { FileItemStyles } from './FileItem';
import { css } from "styled-components";
import i18next from "i18next";


interface IProps {
  files: any[];
  onFileItemClick: Function;
}

const FileListItems: FC<IProps> = ({
  files,
  onFileItemClick
}) => {

  return (
    <div className='file-list-container'>
      <ul className="breadcrumb-2" id="nav-2">
        <li>
          <span id="home-2">
            {i18next.t("documents.drop_down_list_drives")}
          </span>
        </li>
      </ul>
      <div className='file-list'>
        {files.map((file, index) => (
          <FileItem index={index} key={file.id} file={file} onClick={onFileItemClick} />
        ))}
        {files.length <= 0 &&
          <p>{i18next.t("documents.empty_list")}</p>
        }
      </div>
    </div>
  );
};

export default FileListItems;

export const FileListItemsStyles = css`
  .file-list-container{
    over
    .header-title {
        display: block;
        padding: 5px;
    }
    .file-list{
      background-color: #fff;
      padding: 15px;
      box-shadow: 0 3.2px 7.2px rgba(0,0,0,0.132),0 0.6px 1.8px rgba(0,0,0,0.108);
      border: none;
      position: relative;
      display: flex;
      flex-direction: column;
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
    }
    
    ${FileItemStyles}
  }
`;